module.exports = __webpack_public_path__ + "img/icon_3_0.e8410fd0.png";